import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Item from './Item';
import './ListForm.scss';

class ListForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: props.answer,
    };
    this.handleAddItem = this.handleAddItem.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDeleteItem = this.handleDeleteItem.bind(this);
  }

  handleInputChange(value, index) {
    const { list } = this.state;
    const { handleChange, questionKey } = this.props;
    list[index] = value;
    this.setState({ list });
    handleChange(list, questionKey);
  }

  handleAddItem() {
    const { list } = this.state;
    list.push('');
    this.setState({ list });
    const { handleChange, questionKey } = this.props;
    handleChange(list, questionKey);
  }

  handleDeleteItem(index) {
    const { list } = this.state;
    if (list.length === 1) {
      list[index] = '';
    } else {
      list.splice(index, 1);
    }
    this.setState({ list });
    const { handleChange, questionKey } = this.props;
    handleChange(list, questionKey);
  }

  renderList() {
    const { list } = this.state;
    const { questionKey, style } = this.props;
    return (
      <div className="list">
        {list.map((item, index) => (
          <Item
            value={item}
            index={index}
            handleInputChange={this.handleInputChange}
            handleDeleteItem={this.handleDeleteItem}
            itemHeader={pluralize.singular(questionKey)}
            placeholder={questionKey === 'accomplishments' ? '36 INDs and 11 NDA submissions.' : 'Type here...'}
            style={style}
          />
        ))}
      </div>
    );
  }

  render() {
    const { list } = this.state;
    const { limit, questionKey } = this.props;
    if (list.length === 0) {
      this.handleAddItem();
    }
    return (
      <div className="list-question body-text-2">
        {this.renderList()}
        {(limit === null || list.length < limit)
          && (
          <div className="mt-3">
            <a
              role="link"
              tabIndex={0}
              id="add-new-item"
              onClick={() => this.handleAddItem()}
            >
              <i className="fa fa-plus me-2" />
              Add another
              {' '}
              {pluralize.singular(questionKey)}
            </a>
          </div>
          )}
      </div>
    );
  }
}

ListForm.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  limit: PropTypes.number,
  style: PropTypes.string.isRequired,
};

ListForm.defaultProps = {
  limit: null,
};

export default ListForm;
